<div *ngIf="isOpen" [@slideLeftRight] (@slideLeftRight.done)="onSlideLeftRightEnd()"
     class="defaultAside aside-left aside-open shadow-none overflow-auto bg-white" id="processHolder">
    <div class="container-mobile-menu h-100">
        <div class="row h-100">
            <div class="col-3 col-md-4">
                <div class="w-100 d-flex">
                    <a href="javascript:void(0)"
                       class="menu-btn header-sub-item-icon header-sub-item-icon--fill"
                       (click)="startClosing()">
                        <svg-icon src="assets/images/icon-menu-close.svg"></svg-icon>
                    </a>
                    <a href="tel:{{(publicTelNo$ | async)}}"
                       class="header-sub-item-icon me-0">
                        <svg-icon src="assets/images/icon-phone.svg"></svg-icon>
                    </a>
                </div>
            </div>
            <div class="col-6 col-md-4 mx-auto d-flex flex-column align-items-center">
                <a (click)="goToRouteWithDelay($event, '/')">
                    <svg-icon src="assets/images/ys-logo-text.svg" [svgClass]="'header__logo-img'"></svg-icon>
                </a>

                <ul *ngIf="!activeSubId" [@slideMenuPage] class="navbar-nav nav-mobile main-menu">
                    <ng-container *ngFor="let q of (menu$ | async).home; let m = index">
                        <!-- External link -->
                        <li class="nav-item flex-fill" *ngIf="q.external === 1">
                            <a class="nav-link" target="_blank" [href]="[q.externalURL]">{{q.name}}</a>
                        </li>

                        <li *ngIf="q.external === 0">
                            <a
                                *ngIf="q.submenu.length"
                                class="nav-link ff-spectral nav-link--has-sub"
                                href="javascript:void(0)"
                                (click)="toggleSubMenu(q.id)">
                                <div class="d-flex justify-content-between">
                                    {{ q.name }} <svg-icon src="assets/images/icon-arrow-right.svg"></svg-icon>
                                </div>
                            </a>
                            <a
                                *ngIf="!q.submenu.length"
                                class="nav-link ff-spectral"
                                (click)="goToRouteWithDelay($event, q.route)"
                                [class.active]="router.isActive(q.route,false)"
                                >{{q.name}}
                            </a>
                        </li>
                    </ng-container>
                    <li class="border-top border-primary border-1 pt-3 mt-3">
                        <a class="nav-link ff-spectral" [href]="['/contact-us']">Get a free quote</a>
                    </li>
                </ul>

                <ng-container *ngFor="let q of (menu$ | async).home; let m = index">
                    <ul *ngIf="q.submenu.length && activeSubId === q.id" [@slideMenuPage] class="navbar-nav nav-mobile submenu">
                        <li class="nav-item flex-fill">
                            <a
                                class="nav-link"
                                href="javascript:void(0)"
                                (click)="backToMainMenu()">
                                <svg-icon src="assets/images/icon-arrow-left-long.svg"></svg-icon>
                            </a>
                        </li>
                        <li>
                            <a
                                *ngIf="q.route === '/product-ranges' && q.route === '/product-groups'"
                                class="nav-link ff-spectral"
                                (click)="goToRouteWithDelay($event, q.route)"
                                [class.active]="router.isActive(q.route,false)">
                                <ng-container *ngIf="q.route === '/product-groups' || q.route === '/product-ranges'">
                                    View all
                                </ng-container>
                            </a>
                        </li>
                        <ng-container *ngFor="let qSub of q.submenu">
                            <li>
                                <a *ngIf="q.route === '/product-groups'"
                                    class="nav-link ff-spectral"
                                    (click)="goToRouteWithDelay($event,'product-groups/' + qSub.slug)"
                                    [class.active]="router.isActive('product-groups/' + qSub.slug, true)">
                                    {{ qSub.name }}
                                </a>

                                <a *ngIf="q.route === '/product-ranges'"
                                    class="nav-link ff-spectral"
                                    (click)="goToRouteWithDelay($event, 'product-ranges/' + qSub.slug)"
                                    [class.active]="router.isActive('product-ranges/' + qSub.slug, true)">
                                    {{ qSub.name }}
                                </a>

                                <a
                                   *ngIf="q.route !== '/product-ranges' && q.route !== '/product-groups'"
                                   class="nav-link ff-spectral"
                                   (click)="goToRouteWithDelay($event, qSub.route)"
                                   [class.active]="router.isActive(qSub.route, true)">
                                    {{ qSub.name }}
                                </a>
                            </li>
                        </ng-container>
                    </ul>
                </ng-container>
            </div>
            <div class="col-3 col-md-4">
                <div class="w-100 d-flex justify-content-end">
                    <a *ngIf="(deviceType$| async) !== 'mobile'" [routerLink]="['/my-favourites']"
                       class="header-sub-item-icon">
                        <svg-icon src="assets/images/icon-heart.svg"></svg-icon>
                        <span class="badge-count"
                              *ngIf="(favourites$ | async).length">{{(favourites$ | async).length}}</span>
                    </a>
                    <a [routerLink]="['/basket']" class="header-sub-item-icon">
                        <svg-icon src="assets/images/icon-cart.svg"></svg-icon>
                        <span class="badge-count" *ngIf="(basket$ | async).items.length || (basket$ | async).samples.length">{{(basket$ | async).items.length + (basket$ | async).samples.length}}</span>
                    </a>
                    <ng-container *ngIf="!(user$ | async)">
                        <a class="header-sub-item-icon me-0" [routerLink]="['/login']">
                            <svg-icon src="assets/images/icon-user.svg"></svg-icon>
                        </a>
                    </ng-container>
                    <ng-container *ngIf="(user$ | async)">
                        <a class="header-sub-item-icon me-0" (click)="toggleMenuUser()">
                            <svg-icon src="assets/images/icon-user.svg"></svg-icon>
                        </a>
                    </ng-container>
                </div>
            </div>
        </div>
    </div>
</div>
